const categories = {
  'categories-breadcrumbs': 'Categories',
  'categories-details-title': 'Category',
  'categories-filter-title': 'Filter categories',
  'categories-create-form-field-client-id-help': 'Unique ID for "core" client to identify category',
  'categories-create-form-field-name-placeholder': 'Specify category title',
  'categories-create-form-field-description-placeholder': 'Enter description',
  'categories-form-field-options': 'Options',
  'categories-form-field-options-placeholder': 'Enter options',
  'categories-form-field-options-help': 'You may pass different meta options here like target config (min_app_version, core_version etc.) in JSON format. Note: options have higher priority than targets.',
  'categories-create-form-field-dictionary-placeholder': 'Select dictionary',
  'categories-view-images': 'Images',
  'categories-view-images-empty': 'No images',
  'categories-priorities': 'Priorities',
  'categories-deleted-at': 'Was deleted at',
  'categories-priorities-title': 'Drag categories to set correct priority',
  'categories-priorities-empty': 'There are not categories',
  'categories-priorities-disabled-action': 'Drag categories for update',
  'categories-delete-notification': 'If the category contains images, they will be automatically unlinked from the category.',
};

export default categories;
